<template>
  <div
    ref="headerBarElement"
    class="header-sticky-navbar navbar navbar-expand-lg navbar-light bg-light fade-visible"
  >
    <div class="container">
      <ul class="navbar-nav flex-row d-md-flex container-fluid align-items-center">
        <li class="col nav-item align-items-end pr-0">
          <hamburger-menu></hamburger-menu>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import HamburgerMenu from './HamburgerMenu'

export default {
  name: 'HeaderNavbar',
  components: {
    HamburgerMenu,
  },
  data() {
    return {
      position: -1,
      scope: this,
      scrollThreshold: 50,
      logoColor: 'white',
    }
  },
  computed: {
    logoStyling() {
      return this.logoColor
    },
  },
  methods: {
    scrollDone() {
      const headerBar = this.scope.$refs.headerBarElement
      const topScrollPosition = window.scrollY
      if (topScrollPosition > 5) {
        // onscroll add onscroll styling
        headerBar.classList.add('onScrollNav')
        this.logoColor = 'color'
      } else {
        // default, add default styling
        headerBar.classList.remove('onScrollNav')
        this.logoColor = 'white'
      }
      // use a threshold for scrolling which prevents flickering and gives better behaviour.
      if (topScrollPosition <= Math.max(0, this.scope.position - this.scope.scrollThreshold)) {
        headerBar.classList.remove('fade-to-none')
      }
      // clear any timeout.
      clearTimeout(this.scope.scrollTimeout)
      this.scope.scrollTimeout = setTimeout(() => {
        const scrollPosition = window.scrollY
        if (headerBar) {
          // when scrollposition is down, add class to fade it away (when scrolled more than the thershold for smoother experience)
          if (
            scrollPosition > 50 &&
            scrollPosition > this.scope.position + this.scope.scrollThreshold
          ) {
            headerBar.classList.add('fade-to-none')
          }
        }
        this.scope.position = scrollPosition
      }, 100)
    },
  },
  mounted() {
    this.scope.position = window.scrollY
    if (this.$refs.headerBarElement) {
      window.addEventListener('scroll', () => {
        this.scrollDone()
      })
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollDone)
  },
  updated() {
    this.scope.position = window.scrollY
    if (this.$refs.headerBarElement) {
      window.addEventListener('scroll', () => {
        this.scrollDone()
      })
    }
  },
}
</script>
